module.exports = __webpack_public_path__ + "static/media/landing-page_top_min.c0de5e97.jpg";